<template>
	<div class="size">
		<span v-for="(bin, index) in sizeBins"
			:key="index"
			:style="{ width: binWidth(bin, sizeTotal) }">
			<template v-if="bin > 0">
				<div class="icon">
					<i class="el-icon-food"></i>
				</div>
				<label>
					{{ binLabel(bin, sizeTotal) }}
				</label>
			</template>
		</span>
	</div>
</template>
<script>
import FoodAnalysis from '..'

export default {
	name: 'lifestyle-table-size-column',
	extends: FoodAnalysis
}
</script>

<style lang="scss" scoped>
$background: rgb(229, 240, 248);
$border: rgb(144, 184, 212);
$red: rgb(249, 90, 90);
$yellow: rgb(245, 166, 35);
$green: rgb(126, 198, 53);

.size {
	height: 32px;
	> span {
		position: relative;
		float: left;
		height: 12px;
		margin-top: 18px;

		.icon, label {
			position: absolute;
			left: 0px;
			width: 100%;
			text-align: center;
		}

		.icon {
			bottom: 8px;
			line-height: 24px;
			i {
				margin-left: -5px;
			}
		}
		label {
			color: #3f3f3f;
			bottom: -6px;
			font-size: 10px;
			font-weight: 700;
			letter-spacing: 1px;
		}
	}
	span:first-child {
		background: $background;
		color: $border;
		.icon { font-size: 14px; }
	}
	span {
		background: darken($background, 10%);
		color: darken($border, 20%);
		.icon { font-size: 16px; }
	}
	span:last-child {
		background: darken($background, 20%);
		color: darken($border, 40%);
		.icon { font-size: 20px; }
	}
}
</style>
